import React from 'react';
import { Card } from './ui/Card';
import { Badge } from './ui/Badge';
import { Users, BarChart3, MoreHorizontal } from 'lucide-react';
import { Team } from '../types';
interface TeamCardProps {
  team: Team;
  onClick?: () => void;
}
export function TeamCard({
  team,
  onClick
}: TeamCardProps) {
  const colorMap: Record<string, any> = {
    blue: {
      border: 'border-l-blue-500',
      bg: 'bg-blue-50',
      text: 'text-blue-700'
    },
    emerald: {
      border: 'border-l-emerald-500',
      bg: 'bg-emerald-50',
      text: 'text-emerald-700'
    },
    amber: {
      border: 'border-l-amber-500',
      bg: 'bg-amber-50',
      text: 'text-amber-700'
    },
    purple: {
      border: 'border-l-purple-500',
      bg: 'bg-purple-50',
      text: 'text-purple-700'
    }
  };
  const theme = colorMap[team.color] || colorMap.blue;
  return <Card className={`border-l-4 ${theme.border} relative group`} hoverable onClick={onClick} data-id="element-62">
      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-63">
        <button className="p-1 hover:bg-gray-100 rounded-full text-gray-400 hover:text-gray-600" data-id="element-64">
          <MoreHorizontal className="h-5 w-5" data-id="element-65" />
        </button>
      </div>

      <div className="flex items-start justify-between mb-4" data-id="element-66">
        <div data-id="element-67">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-68">{team.name}</h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-69">{team.campaignName}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-70">
        <div className="flex items-center space-x-2" data-id="element-71">
          <Users className="h-4 w-4 text-gray-400" data-id="element-72" />
          <span className="text-sm font-medium text-gray-700" data-id="element-73">
            {team.users.length} Users
          </span>
        </div>
        <div className="flex items-center space-x-2" data-id="element-74">
          <BarChart3 className="h-4 w-4 text-gray-400" data-id="element-75" />
          <span className="text-sm font-medium text-gray-700" data-id="element-76">
            {team.totalLeadsDistributed} Leads
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-77">
        <Badge variant={team.active ? 'success' : 'neutral'} data-id="element-78">
          {team.active ? 'Active' : 'Paused'}
        </Badge>
        <span className={`text-xs font-medium px-2 py-1 rounded ${theme.bg} ${theme.text}`} data-id="element-79">
          {team.distributionMethod === 'round-robin' ? 'Round Robin' : 'Weighted'}
        </span>
      </div>
    </Card>;
}